import { render, staticRenderFns } from "./PaymentMethodsList.vue?vue&type=template&id=42ca52ef&scoped=true&"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsList.vue?vue&type=style&index=0&id=42ca52ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca52ef",
  null
  
)

export default component.exports